import React from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import UserOverview from './UserOverview';

const Admin = () => {
  return (
    <>
      <PageHeader container="Admin" header={'Administration'} />
      <UserOverview />
    </>
  );
};

export default Admin;
